import React, { useState, useRef } from "react";
import f1 from "../img/f1.png";
import eye from "../img/eye.png";
import { useNavigate } from "react-router-dom";
import { supabaseAnon } from "../db";

const Login = ({ email, setEmail, password, setPassword }) => {
  // Initialising useNavigate + useRef
  const navigate = useNavigate();
  const emailRef = useRef(null);
  const passwordRef = useRef(null);
  const [isPasswordHidden, setIsPasswordHidden] = useState(false);
  const [invalidFields, setInvalidFields] = useState({
    email: false,
    password: false,
  });
  const [createAccount, setCreateAccount] = useState(false);

  // Entry function called when submit button is pressed
  const handleClick = () => {
    // Resetting all of the inputs
    setInvalidFields({ email: false, password: false, confirmPassword: false });
    handleLoginRequest();
  };

  const handleLoginRequest = async () => {
    const response = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/api/users/login?email=${email}&password=${password}`
    );
    const data = await response.json();

    console.log("Login response data:", data);

    // Calls the endpoint for setting the session to cookies
    if (data.message.login === true) {
      if (data.message.session !== "Email not confirmed") {
        // send session to backend to set cookies
        const cookieRes = await fetch(
          `${process.env.REACT_APP_BACKEND_URL}/api/users/create-session`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            credentials: "include", // 🔑 allow cookies to be sent back
            body: JSON.stringify({ session: data.message.session }),
          }
        );

        if (!cookieRes.ok) {
          console.error("cookie setting failed");
          return;
        }

        console.log("Navigating to dashboard.....");
        navigate("/dashboard");
      } else {
        alert("Please verify your email before logging in");
        return;
      }
    }

    switch (data.message.status) {
      case "User not authenticated":
        setInvalidFields((prev) => ({ ...prev, email: true }));
        alert("Email not verified, please verify your account");
        break;
      case "Invalid login credentials":
        setInvalidFields((prev) => ({ ...prev, password: true }));
        alert("Inavlid password or email address, Please try again");
        break;
      case "User not found":
        setInvalidFields((prev) => ({ ...prev, email: true }));
        setCreateAccount(true); 
        alert("User not found, Please sign up first");
        break;
    }
  };

  return (
    <div className="form-container">
      <form className="form" onSubmit={(e) => e.preventDefault()}>
        <div className="form-header">Sign in to TelemetryLab</div>

        <input
          type="text"
          name="email"
          ref={emailRef}
          placeholder="Email Address..."
          className={invalidFields.email ? "input-error" : "input"}
          value={email}
          required
          onChange={(e) => setEmail(e.target.value)}
        />
        <div className="password-input">
          <input
            className={invalidFields.password ? "input-error" : "input"}
            type={isPasswordHidden ? "text" : "password"}
            ref={passwordRef}
            name="password"
            placeholder="Password..."
            value={password}
            required
            onChange={(e) => setPassword(e.target.value)}
          />
          <button
            className="hide-button"
            onClick={(e) => {
              e.preventDefault();
              setIsPasswordHidden((prev) => !prev);
            }}
          >
            <img src={eye} />
          </button>
        </div>
        <input
          type="submit"
          id="submit"
          name="submit"
          value={"Log in"}
          onClick={handleClick}
        />
      </form>

      {createAccount && 
        <div className="create-account-prompt">
          <p>Don't have an account?</p>
          <button
            onClick={() => navigate("/create-account")}
            className="create-account-button"
          >
            Create Account
          </button>
        </div> 
      }

      <div className="image-container">
        <img src={f1} />
      </div>
    </div>
  );
};

export default Login;
